import { render, staticRenderFns } from "./LessonDelete.vue?vue&type=template&id=31c7a74e&"
import script from "./LessonDelete.vue?vue&type=script&lang=js&"
export * from "./LessonDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports